/**
 * httpリクエスト処理
 */
import common from '@/mixin/common';
// Ajax通信ライブラリ
import 'whatwg-fetch';

const URL = '';

export default {
  created: function () {
    this.URL = process.env.WEB_API_ORIGIN + "/rosettaapi/";
  },
  mixins: [
    common,
  ],
  methods: {
    /**
     * HTTPリクエスト
     *
     * @param {String} path URL拡張パス
     * @param {String} method HTTPメソッド
     * @param {String} param リクエストパラメータ
     * @param {String} accessKey アクセスキー(未指定可)
     */
    request: function (path, method, param, accessKey) {
      var self = this;
      var headers = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' };

      // アクセスキー設定
      if (accessKey) {
        headers['X-RS-Access-Key'] = accessKey;
      }

      // fetchオプションの設定
      var options = {
        method: method,
        mode: 'cors',
        credentials: 'include',
        headers: headers,
      };

      // リクエストパラメータ
      if (param) {
        options.body = param;
      }

      // リクエスト実行
      return new Promise(function (resolve, reject) {
        fetch(self.URL + path, options).then(function (response) {
          self.log(path + " response.status: " + response.status);
          if(response.status != 200) {
            reject(response.status);
          }

          resolve(response.json());
        }).catch (function(error) {
          self.log(path + " error: " + error);
          reject('');
        });
      });
    },
    /**
     * HTTPリクエスト(アクセスキー付与)
     *
     * @param {String} path URL拡張パス
     * @param {String} method HTTPメソッド
     * @param {String} param リクエストパラメータ
     * @param {String} accessKey アクセスキー(未指定可)
     */
    requestWithAccessKey: async function (path, method, param, accessKey) {
      // アクセスキーが指定されなかった場合、ここで取得
      var key = accessKey;
      if (!key) {
        key = await storage_wrapper.getRsAccessKey();
      }
      // HTTPリクエスト
      return this.request(path, method, param, key);
    },
    /**
     * ログインAPI
     *
     * @param {String} email メールアドレス
     * @param {String} password パスワード
     * @param {String} contentId コンテンツID
     */
    login: function (email, password, contentId) {
      this.log("http start login");
      // 入力パラメータの設定
      var param = 'email=' + encodeURIComponent(email) + '&password=' + password + '&contentid=' + contentId;
      // HTTPリクエスト
      return this.request('platform/login', 'POST', param);
    },
    /**
     * シリアル入力API
     *
     * @param {String} contentid コンテンツID
     * @param {String} serial シリアル
     * @param {String} accessKey アクセスキー(未指定可)
     */
    activate: function (contentid, serial, accessKey) {
      this.log("http start activate");
      // 入力パラメータの設定
      var param = 'contentid=' + contentid + '&serial=' + serial;
      // HTTPリクエスト
      return this.requestWithAccessKey('platform/activate', 'POST', param, accessKey);
    },
    /**
     * ログアウトAPI
     *
     * @param {String} accessKey アクセスキー(未指定可)
     */
    logout: function (accessKey) {
      this.log("http start logout");
      // HTTPリクエスト
      return this.requestWithAccessKey('logout', 'GET', null, accessKey);
    },
    /**
     * コンテンツ名取得API
     *
     * @param {String} contentid コンテンツID
     */
    getContentName: function (contentid) {
      this.log("http start getContentName");
      // 入力パラメータの設定
      var param = 'contentid=' + contentid;
      // HTTPリクエスト
      return this.request('getcontentname', 'POST', param);
    },
    /**
     * コンテンツ情報一覧取得API
     *
     * @param {String} accessKey アクセスキー(未指定可)
     */
    getContentList: function (accessKey) {
      this.log("http start getContentList");
      // HTTPリクエスト
      return this.requestWithAccessKey('getcontentlist', 'GET', null, accessKey);
    },
    /**
     * 購入済みコンテンツ更新API
     *
     * @param {String} accessKey アクセスキー(未指定可)
     */
    updateContentList: function (accessKey) {
      this.log("http start updateContentList");
      // HTTPリクエスト
      return this.requestWithAccessKey('updatecontentlist', 'GET', null, accessKey);
    },
    /**
     * コンテンツマスタ情報一覧取得API
     */
    getMasterContentList: function() {
      this.log("http start getMasterContentList")
      // HTTPリクエスト
      return this.request('getmastercontentlist', 'GET', null)
    },
    /**
     * 辞書API
     *
     * @param {String} word 検索ワード
     * @param {String} mode 検索モード
     * @param {String} accessKey アクセスキー(未指定可)
     */
    dictionary: function (word, mode, accessKey) {
      this.log("http start dictionary");
      // 入力パラメータの設定
      var param = 'word=' + word + "&mode=" + mode;
      // HTTPリクエスト
      return this.requestWithAccessKey('dictionary', 'POST', param, accessKey);
    },
    /**
     * au版Androidアプリ利用開始API
     *
     * @param {String} uuid Androidアプリで生成されたUUID
     */
    auActivate: function (uuid) {
      this.log("http start auActivate");
      // 入力パラメータの設定
      var param = 'uuid=' + uuid;
      // HTTPリクエスト
      return this.request('auactivate', 'POST', param);
    },
    /**
     * 引き継ぎコード利用開始API
     *
     * @param {String} takeOverCode 引継ぎコード
     * @param {String} password パスワード
     */
    takeOverActivate: function (takeOverCode, password) {
      this.log("http start takeOverActivate");
      // 入力パラメータの設定
      var param = 'takeovercode=' + takeOverCode + '&passhash=' + this.getSha256HashHexString(password);
      // HTTPリクエスト
      return this.request('takeoveractivate', 'POST', param);
    },
    /**
     * 引き継ぎコード取得API
     *
     * @param {String} password パスワード
     * @param {String} accessKey アクセスキー(未指定可)
     */
    getTakeOverCode: function (password, accessKey) {
      this.log("http start getTakeOverCode");
      // 入力パラメータの設定
      var param = 'passhash=' + this.getSha256HashHexString(password);
      // HTTPリクエスト
      return this.requestWithAccessKey('gettakeovercode', 'POST', param, accessKey);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/http.js